import ShopBanner from './ShopBanner';

export * from './ShopBanner';
export default ShopBanner;
